module.exports = __webpack_public_path__ + "static/centurylink-logo-black-text-c7f65c1e6dbecedf4d48cffc9caac48c.png";